export const removeTrailingSlash = (str: string) => str.replace(/\/$/, '');
